import { CorporateClient } from "./fo.api.service";

const API_URL = window.config?.VITE_API_HOST;

class CorporateService {
  client = null;
  postal_codes_client = null;

  constructor(token) {
    this.client = new CorporateClient(API_URL);
    this.client.setAuthToken(token);
  }

  static getInstance(token) {
    const service = new CorporateService(token);
    return service;
  }

  exportInventoryForTerminal(params) {
    return new Promise((resolve, reject) => {
      this.client
        .exportInventoryForTerminal(params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getTrackingUnitLookup(params) {
    return new Promise((resolve, reject) => {
      this.client
        .trackingUnitDetail(params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }



  getDoorsList() {
    return new Promise((resolve, reject) => {
      this.client
        .doorsList()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  addDoor(door) {
    return new Promise((resolve, reject) => {
      this.client
        .newDoor(door)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  addLocation(location) {
    return new Promise((resolve, reject) => {
      this.client
        .newLocation(location)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  removeLocation(code) {
    return new Promise((resolve, reject) => {
      this.client
        .removeLocation(code)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getLocations() {
    return new Promise((resolve, reject) => {
      this.client
        .locationsList()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getLocationsByTerminalList(terminal) {
    console.log('here', terminal);
    return new Promise((resolve, reject) => {
      this.client
        .locationsByTerminalList(terminal)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  locationsByTerminalListGrouped(terminal) {
    console.log('here', terminal);
    return new Promise((resolve, reject) => {
      this.client
        .locationsByTerminalListGrouped(terminal)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getInventoryByTerminal(terminal) {
    return new Promise((resolve, reject) => {
      this.client
        .getInventoryByTerminal(terminal)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  addNewHubTerminal(terminal) {
    return new Promise((resolve, reject) => {
      this.client
        .newTerminal(terminal)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getHubTerminalsList() {
    return new Promise((resolve, reject) => {
      this.client
        .hubTerminalsList()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getPostalCodePrefixList() {
    return new Promise((resolve, reject) => {
      this.client
        .postalCodePrefixList()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getLanesList() {
    return new Promise((resolve, reject) => {
      this.client
        .lanesList()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getLane(code) {
    return new Promise((resolve, reject) => {
      this.client
        .getLane(code)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  addNewLane(lane) {
    return new Promise((resolve, reject) => {
      this.client
        .newLane(lane)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  removeLane(code) {
    return new Promise((resolve, reject) => {
      this.client
        .removeLane(code)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  addNewZone(zone) {
    return new Promise((resolve, reject) => {
      this.client
        .newZone(zone)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getZonesList() {
    return new Promise((resolve, reject) => {
      this.client
        .zonesList()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getZone(code) {
    return new Promise((resolve, reject) => {
      this.client
        .getZone(code)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getInventoryForBay(terminal, row, bay) {
    return new Promise((resolve, reject) => {
      this.client
        .getInventoryForBay(terminal, row, bay)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  validateInventory(barcode, terminal, location) {
    return new Promise((resolve, reject) => {
      this.client
        .validateInventory(barcode, {
          barcode: barcode,
          terminal: terminal,
          location: location,
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default CorporateService;
